import firebase from "firebase/app";
import "firebase/analytics";
import "firebase/firestore";

const config = {
  apiKey: "AIzaSyBp8Ju5O1y8XqiKiu03nr4lrLIRWIm1_H8",
  authDomain: "dixit-7306e.firebaseapp.com",
  databaseURL: "https://dixit-7306e.firebaseio.com",
  projectId: "dixit-7306e",
  storageBucket: "dixit-7306e.appspot.com",
  messagingSenderId: "713686519222",
  appId: "1:713686519222:web:b7c73d256fd4205fd68517",
  measurementId: "G-EHBCT60JQT"
};

firebase.initializeApp(config);
firebase.analytics();

export const db = firebase.firestore();
